import Vue from "vue";
import Vuex from "vuex";
import user from "./store/modules/user";
import events from "./store/modules/events";
import persons from "./store/modules/persons";
import hotels from "./store/modules/hotels";
import facilities from "./store/modules/facilities";
import router from "@/router";

import { Api } from "@/core/api.js";
const api = new Api();

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

let notifier = new Vue();

export default new Vuex.Store({
  state: {
    language: localStorage.language ? localStorage.language : "cat",
    languages: [],
    title: "MIC Colaboradores",
    app_url: "http://localhost:8087",
    table_relatioship: false,
    countries: [],
    how_meet: [],
    contact_type: {},
    category_type: {},
    alergy: {},
    campus_type: {},
    events: [],
    events_type: [],
    staff_level: [],
    studies: [],
    wroking_areas: [],
    language_volunteer: [],
    role_volunteer: [],
    volunteer_3po_options: [],
    event_type: "",
    event_color: "",
    redirect_page: "",
    shirt_size: {},
    event_information: {},
    volunteer_shirt_size: {},
    volunteer_shoes_size: {},
    alergy: {},
    diet: {},
    reject_documents: {},
    tablesLoaded: false,
    tablesLoading: false
  },
  modules: {
    user,
    events,
    persons,
    hotels,
    facilities
  },
  strict: debug,
  mutations: {
    setOverlayVisible(state, value) {
      state.overlay_is_visible = value;
    },

    setTopbarActionsVisible(state, value) {
      state.topbar_actions_visible = value;
    },

    setMenuVisible(state, value) {
      state.menu_is_visible = value;
    },

    setUserMenuVisible(state, value) {
      state.usermenu_is_visible = value;
    },

    setEventListVisible(state, value) {
      state.show_event_list = value;
    },

    setEventSelected(state, value) {
      state.event_selected = value;
    },

    setLoading(state, value) {
      state.is_loading = value;
    },

    setLoadingTables (state, value) {
      state.tablesLoading = value
    },

    setLanguage(state, value) {
      for (var k in this.languages) {
        if (this.languages[k].name == value) this.languages[k].selected = true;
        else this.languages[k].selected = false;
      }
      state.language = value;
      localStorage.language = value;
    },

    setTables(state, tables) {
      state.table_relatioship = true;

      if (typeof tables["country"] !== "undefined") {
        state.countries = tables["country"];
      }
      if (typeof tables["contact_type"] !== "undefined") {
        state.persons.contact_types = tables["contact_type"];
      }
      if (typeof tables["rel_status_event"] !== "undefined") {
        state.events.status_entities = tables["rel_status_event"];
      }
      if (typeof tables["how_meet"] !== "undefined") {
        state.how_meet = tables["how_meet"];
      }
      if (typeof tables["mode_register_event"] !== "undefined") {
        state.modes_registered = tables["mode_register_event"];
      }
      if (typeof tables["user"] !== "undefined") {
        state.user.list = tables["user"];
      }
      if (typeof tables["language"] !== "undefined") {
        state.languages = tables["language"];
      }
      if (typeof tables["staff_level"] !== "undefined") {
        state.staff_level = tables["staff_level"];
      }
      if (typeof tables["event"] !== "undefined") {
        state.events.list = tables["event"];
      }
      if (typeof tables["event_type"] !== "undefined") {
        state.events_type = tables["event_type"];
      }
      if (typeof tables["studies"] !== "undefined") {
        state.studies = tables["studies"];
      }
      if (typeof tables["working_areas"] !== "undefined") {
        state.working_areas = tables["working_areas"];
      }
      if (typeof tables["language_volunteer"] !== "undefined") {
        state.language_volunteer = tables["language_volunteer"];
      }
      if (typeof tables["role_volunteer_event"] !== "undefined") {
        state.role_volunteer = tables["role_volunteer_event"];
      }
      if (typeof tables["volunteer_3po_options"] !== "undefined") {
        state.volunteer_3po_options = tables["volunteer_3po_options"];
      }
      if (typeof tables["volunteer_shirt_size"] !== "undefined") {
        state.volunteer_shirt_size = tables["volunteer_shirt_size"];
      }
      if (typeof tables["volunteer_shoes_size"] !== "undefined") {
        state.volunteer_shoes_size = tables["volunteer_shoes_size"];
      }
      if (typeof tables["alergy"] !== "undefined") {
        state.alergy = tables["alergy"];
      }
      if (typeof tables["diet"] !== "undefined") {
        state.diet = tables["diet"];
      }
      if (typeof tables["reject_documents"] !== "undefined") {
        state.reject_documents = tables["reject_documents"];
      }
      state.tablesLoaded = true
      state.tablesLoading = false
    },

    setCurrentPage(state, page) {
      state.current_page = page;
    },

    setEventInformation(state, value) {
      state.event_information = value;
    }
  },
  actions: {
    getInscriptionsInfo: ({ commit }, params) => {
      return api.get("volunteer/inscription").then(function(response) {
        return commit("setTables", response.data);
      });
    },

    setPage({ commit, dispatch, state }, page) {
      // notifier.$overlay.loading()

      return new Promise((resolve, reject) => {
        resolve();
        /*
			if( page.name != 'home' && page.name != 'event_home' ){
				commit( 'setTopbarActionsVisible', true );
				commit( 'setMenuVisible', true );
				commit( 'setTopbarButtonsVisible', true );
			}
			else{
				commit( 'setTopbarActionsVisible', false );
				commit( 'setMenuVisible', false );
			}
			
			var page2 = page.name.replace( 'event_', '' );

			commit( 'setUserMenuVisible', false );
			commit( 'setEventListVisible', false );

			commit( 'setCurrentPage', page2 );
			commit( 'navigation/pushPage', page );

			if( page.name.includes( 'event_' ) && !state.event_selected ){
				var event = page.params.event;
				commit( 'setEventSelected', true );
				//TODO THIS ONLY WORKS WITH ACTIVES EVENTS, WE'LL NEED CHANGE TO 
				// var current_events = [...state.events.actives];
				// for( var i in current_events ){
				// 	if( ( current_events[ i ].name + current_events[ i ].edition.substring(2) ).toLowerCase() == event ) commit( 'events/setCurrentEvent', current_events[ i ] );
				// }
				//console.log( "--- DISPATCH LOAD BY NAME: " + event + " ---" );
				dispatch( 'events/loadByName', event ).then( function(){resolve()} );
			}
			else if( !page.name.includes( 'event_' ) ) {
				commit( 'setEventSelected', false );
				commit( 'events/setCurrentEvent', {});
				resolve();
			}
			else{
				resolve();
			}
			*/
      });
    },

    loadUser({ commit, dispatch }) {
      return api.get("volunteer/init").then(function(data) {
        if (data.status) {
          dispatch("loadTablesRelationship");
          commit("events/setEventsActive", data.data.events);
          return commit("user/setAuthenticate", data.data);
        }
      });
    },

    loadTablesRelationship: ({ commit }) => {
      return api.get("table").then(function(data) {
        if (data.status) {
          return commit("setTables", data.data);
        }
      });
    },

    getRelVolunteerEvent: ({ commit }, params) => {
      return api
        .get(
          "volunteer/" + params.person_id + "/event/" + params.event_id + "/get"
        )
        .then(function(response) {
          return commit("setEventInformation", response.data);
        });
    },

    upload(context, data) {
      var document = { ...data };
      let form = new FormData();

      Object.entries(document.files).forEach(([key, value]) => {
        form.append(key, document.files[key]);
      });

      form.append("id", document.id);
      form.append("event_id", document.event_id);

      return api
        .import("volunteer/upload/documents", form)
        .then(function(response) {
          return response;
        });
    },

    updateDocuments: ({ commit }, params) => {
      return api
        .post("volunteer/updateDocuments", params)
        .then(function(response) {
          return response;
        });
    },

    updateEventInformation: ({ commit }, params) => {
      var document = { ...params.files };
      let form = new FormData();
      Object.entries(document).forEach(([key, value]) => {
        form.append(key, document[key]);
      });

      for (var i in params.input) {
        form.append(i, params.input[i]);
      }
      console.log(form, params.input);
      return api
        .import(
          "volunteer/" +
            params.person_id +
            "/event/" +
            params.event_id +
            "/update",
          form,
          params.input
        )
        .then(function(response) {
          console.log(response);
          return response;
        });
      //   return api
      //     .post(
      //       "volunteer/" +
      //         params.person_id +
      //         "/event/" +
      //         params.event_id +
      //         "/update",
      //       params.input
      //     )
      //     .then(function(response) {
      //       return response;
      //     });
    },

    getIndividualCommitmentHtml: (context, params) => {
      const lang = params.language || "ca";
      const token = encodeURIComponent(localStorage.token || "");
      const path =
        "volunteer/" +
        params.person_id +
        "/event/" +
        params.event_id +
        "/individual-commitment/" +
        lang +
        "/" +
        token +
        "/print";
      return api.get(path).then(function(response) {
        if (response.status) {
          return response.data;
        }
        return false;
      });
    },

    signIndividualCommitment: (context, params) => {
      const form = {
        accept_1: 1,
        accept_2: 1,
        language: params.language || "ca"
      };
      const path =
        "volunteer/" +
        params.person_id +
        "/event/" +
        params.event_id +
        "/individual-commitment/sign";
      return api.post(path, form).then(function(response) {
        return response;
      });
    },

    loadMICUser({ commit, dispatch, state }, params) {
      return api
        .get("volunteer/initmicpreview/" + params.token + "/" + params.entityid)
        .then(function(response) {
          if (response.status) {
            localStorage.setItem("token", response.data.token);
            dispatch("loadTablesRelationship");
            commit("events/setEventsActive", response.data.events);
            return commit("user/setAuthenticate", response.data);
          }
        });
    }
  },
  getters: {
    getLanguages: (state, getter, rootState) => {
      return state.languages;
    },

    getCountries: (state, getters, rootState) => {
      return state.countries;
    },

    getEvents: (state, getters, rootState) => {
      return state.events;
    },

    getEventsType: (state, getters, rootState) => {
      return state.events_type;
    },

    getStudies: (state, getters, rootState) => {
      return state.studies;
    },

    getWorkingAreas: (state, getters, rootState) => {
      return state.working_areas;
    },

    getStaffLevel: (state, getter, rootState) => level => {
      if (level == undefined) return state.staff_level;
      else {
        var levelReturn = {};
        for (var k in state.staff_level) {
          if (level == k) {
            levelReturn = state.staff_level[k];
          }
        }

        return levelReturn;
      }
    },

    getLanguageVolunteer: (state, getters, rootState) => {
      return state.language_volunteer;
    },

    getRoleVolunteer: (state, getters, rootState) => {
      return state.role_volunteer;
    },

    get3poOptions: (state, getters, rootState) => {
      return state.volunteer_3po_options;
    },

    getCurrentPage: (state, getters, rootState) => {
      return state.current_page;
    },

    getCountryByID: (state, getter, rootState) => id => {
      return state.countries[id];
    },

    getHowMeet: (state, getter, rootState) => {
      return state.how_meet;
    },

    getOverlayVisible: (state, getter, rootState) => {
      return state.overlay_is_visible;
    },

    getUser: (state, getters, rootState) => {
      return state.user.user;
    },

    getEventInformation: (state, getters, rootState) => {
      return state.event_information;
    },

    getVolunteerShirtSize: (state, getters, rootState) => {
      return state.volunteer_shirt_size;
    },

    getVolunteerShoesSize: (state, getters, rootState) => {
      return state.volunteer_shoes_size;
    },

    getDiets: (state, getter, rootState) => {
      return state.diet;
    },

    getAlergy: (state, getter, rootState) => {
      return state.alergy;
    },

    getRejectDocuments: (state, getters, rootState) => id => {
      return typeof id !== "undefined"
        ? state.reject_documents[id]
        : state.reject_documents;
    },

    isMobile: (state, getter, rootState) => {
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
});
